import React from "react";

// components
import NoData from "components/NoData";
import Loader from "components/UiKit/Loader";
import CartChemicalProbes from "components/Carts/CartChemicalProbes";

// Interface
interface IList {
  size?: number;
  page?: number;
  loading?: boolean;
  data?: any;
}

export const List: React.FC<IList> = (props) => {
  const { data, page = 1, size = 0, loading } = props;

  const getNoData = () => {
    return <div
      style={{ height: "5rem" }}
      className="flex flex-ai-center flex-jc-center mt30 mb30"
    >
      <NoData text="No data" />
    </div>;
  };

  const getList = (data: any) => {
    return data?.map(
      (item: any, index: number) => {
        const numeration = `${page * +size + index + 1}`;
        return (
          <CartChemicalProbes
            {...item}
            key={index}
            numeration={numeration}

            uniqId={index === 1 ? 'chemical-probes-ebc-id' : ''}
            uniqIdDoi={index === 1 ? 'chemical-probes-doi' : ''}
            uniqIdPrice={index === 0 ? 'chemical-probes-price' : ''}
            uniqIdCheckbox={index === 1 ? 'chemical-probes-checkbox' : ''}
          />
        );
      });
  };

  const getLoader = () => {
    return <div className="libraries-compounds__loader relative mt30 mb30 flex flex-ai-center flex-jc-center full-width">
      <Loader type="circle" color="dark" />
    </div>;
  };

  return (
    <div className="chemical-probes__list">
      {loading ?
        getLoader()
        :
        data?.length
          ? getList(data)
          : getNoData()}
    </div>
  );
};

export default List;
